export type ThemeColors = {
  success: string[];
  warning: string[];
  error: string[];
  gray: string[];
  TEDRed: string[];
  black: string;
  white: string;
  blue: string;
};

export default {
  success: ['#26a65b', '#e0f2e8'],
  warning: ['#e5af0a', '#faf0cf'],
  error: ['#d91e18', '#ffeeef'],
  gray: ['#494949', '#717171', 'rgba(18, 18, 18, .12)', '#F6F6F6'],
  TEDRed: ['#EC1015', 'rgba(236, 16, 21, 0.15)'],
  black: '#121212',
  white: '#FFFFFF',
  blue: '#2763FF',
} as ThemeColors;
